import UserGarageVehicleItem from './UserGarageVehicleItem'
import userGarageVehicleContainer from './userGarageVehicleItemContainer'

export default userGarageVehicleContainer(UserGarageVehicleItem)
